import React from 'react';
import { BorderedList } from '../BorderedList';
import { ALL_CITIES, METALS } from '../types';
import { SidebarHeading } from './SidebarHeading';

interface SIDEBAR_PROPS {
  city: string;
  cityData: ALL_CITIES;
  metal: METALS;
}

export const Sidebar = ({
  city,
  cityData,
  metal,
}: SIDEBAR_PROPS): JSX.Element => {
  return (
    <>
      <SidebarHeading
        heading={`${metal} RATES IN INDIA`}
        isActive={city.toLowerCase() === 'india'}
        link={`/${metal}-rate-india`}
      />

      <SidebarHeading heading={`${metal} RATES IN METRO CITIES`} />
      <BorderedList
        list={cityData.metro_city}
        activeValue={city}
        basePath={`${metal}-rate`}
        metal={metal}
      />

      <SidebarHeading heading={`${metal} RATES IN MAJOR CITIES`} />
      <BorderedList
        list={cityData.major_city}
        activeValue={city}
        basePath={`${metal}-rate`}
        metal={metal}
      />
    </>
  );
};
